export default [
  {
    path: "/game-provider/merchants",
    name: "game-provider.merchants",
    meta: {
      title: "Merchant on Game Provider",
      authRequired: true,
      resource: 'Tenant',
      action: 'gps.merchant.merchants.view',
      application: 'game-provider-application',
      breadcrumb: () => [
        { text: 't-game-provider', to: null, class: 'text-dark' },
        { text: 't-merchants', to: null },
      ]
    },
    component: () => import("@/views/gameProviders/merchants/index.vue")
  },
  {
    path: "/game-provider/master-account",
    name: "game-provider.master-accounts",
    meta: {
      title: "Master Account on Game Provider",
      authRequired: true,
      resource: 'Tenant',
      action: 'gps.provider.master-account.view',
      application: 'game-provider-application',
      breadcrumb: () => [
        { text: 't-game-provider', to: null, class: 'text-dark' },
        { text: 't-master-accounts', to: null },
      ]
    },
    component: () => import("@/views/gameProviders/masterAccounts/index.vue")
  },
  {
    path: "/game-provider/master-account/:masterAccountUuid",
    name: "game-provider.master-accounts.detail",
    meta: {
      title: "Master Account Details on Game Provider",
      authRequired: true,
      resource: 'Tenant',
      action: 'gps.provider.master-account.view',
      application: 'game-provider-application',
      breadcrumb: () => [
        { text: 't-game-provider', to: null, class: 'text-dark' },
        { text: 't-master-accounts', to: { name: 'game-provider.master-accounts' } },
        { text: 't-details', to: null }
      ]
    },
    component: () => import("@/views/gameProviders/masterAccounts/detail.vue")
  },
  {
    path: "/game-provider/merchants/:merchantUuid/providers",
    name: "game-provider.merchant.providers",
    meta: {
      title: "Merchant Providers on Game Provider",
      authRequired: true,
      resource: 'Tenant',
      action: 'gps.merchant.providers.view',
      application: 'game-provider-application',
      breadcrumb: () => [
        { text: 't-game-provider', to: null, class: 'text-dark' },
        { text: 't-merchants', to: { name: 'game-provider.merchants' } },
        { text: 't-merchant-providers', to: null }
      ]
    },
    component: () => import("@/views/gameProviders/merchants/providers/index.vue")
  },
  {
    path: "/game-provider/merchants/:merchantUuid/providers/:merchantProviderUuid",
    name: "game-provider.merchant.provider.detail",
    meta: {
      title: "Merchant Provider Details on Game Provider",
      authRequired: true,
      resource: 'Tenant',
      action: 'gps.merchant.providers.view',
      application: 'game-provider-application',
      breadcrumb: () => [
        { text: 't-game-provider', to: null, class: 'text-dark' },
        { text: 't-merchants', to: { name: 'game-provider.merchants' } },
        { text: 't-merchant-providers', to: { name: 'game-provider.merchant.providers' } },
        { text: 't-merchant-provider-details', to: null }
      ]
    },
    component: () => import("@/views/gameProviders/merchants/providers/detail.vue")
  },
  {
    path: "/game-provider/merchant-providers/:merchantProviderUuid/games",
    name: "game-provider.merchant.provider.games",
    meta: {
      title: "Merchant Provider Game on Game Provider",
      authRequired: true,
      resource: 'Tenant',
      action: 'gps.merchant.provider-game.view',
      application: 'game-provider-application',
      breadcrumb: () => [
        { text: 't-game-provider', to: null, class: 'text-dark' },
        { text: 't-merchants', to: { name: 'game-provider.merchants' } },
        {
          text: 't-merchant-providers',
          to: {
            name: 'game-provider.merchant.providers',
            params: { merchantUuid: history.state?.merchant_uuid }
          }
        },
        { text: 't-merchant-provider-games', to: null }
      ]
    },
    component: () => import("@/views/gameProviders/merchants/providers/games/index.vue")
  },
  {
    path: "/game-provider/downtime-schedule",
    name: "game-provider.downtime-schedules",
    meta: {
      title: "Downtime Schedules on Game Provider",
      authRequired: true,
      resource: 'Tenant',
      action: 'gps.provider.downtime-schedules.view',
      application: 'game-provider-application',
      breadcrumb: () => [
        { text: 't-game-provider', to: null, class: 'text-dark' },
        { text: 't-downtime-schedules', to: null },
      ]
    },
    component: () => import("@/views/gameProviders/downtimeSchedules/index.vue")
  },
  {
    path: "/game-provider/score-watchers",
    name: "game-provider.score-watchers",
    meta: {
      title: "Score Watchers on Game Provider",
      authRequired: true,
      resource: 'Tenant',
      action: 'gps.monitoring.score-watchers.view',
      application: 'game-provider-application',
      breadcrumb: () => [
        { text: 't-game-provider', to: null, class: 'text-dark' },
        { text: 't-score-watchers', to: null },
      ]
    },
    component: () => import("@/views/gameProviders/scoreWatchers/index.vue")
  }
];